<ion-row>
  <ion-col size="12">
    <div class="ion-text-center ion-text-wrap">
      <h2 class="advisor-title intro-title top-title">Want to reserve your seat but need to talk to someone? <br>
        Schedule a call with a dedicated advisor.
      </h2>
    </div>
    <div class="ion-text-center ion-text-wrap">
      <hr>
      <app-calendly></app-calendly>
    </div>
  </ion-col>
</ion-row>